import { render, staticRenderFns } from "./EmailSettingsNotAvailableTab.vue?vue&type=template&id=3c90c161&"
import script from "./EmailSettingsNotAvailableTab.vue?vue&type=script&lang=js&"
export * from "./EmailSettingsNotAvailableTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports